import React from "react";

/**
 * This context is intended to hold theme configuration details for the form, primarily for the
 * legacy components reused in the form.
 */
export const FormThemeContext = React.createContext({
  // Properties for rows with a text input field
  textInputRow: {
    inputWrapperElement: undefined,
    inputWrapperClassName: undefined,
    inputClassName: undefined,
    labelElement: undefined,
    labelClassName: undefined,
    wrapperElement: undefined,
    wrapperClassName: undefined,
    inputErrorClassName: undefined
  },
  // Properties for rows with a select input field
  selectInputRow: {
    inputWrapperElement: undefined,
    inputWrapperClassName: undefined,
    inputClassName: undefined,
    labelElement: undefined,
    labelClassName: undefined,
    wrapperElement: undefined,
    wrapperClassName: undefined
  },
  // Properties for rows with a checkbox
  checkboxRow: {
    inputWrapperElement: undefined,
    inputWrapperClassName: undefined,
    inputClassName: undefined,
    labelElement: undefined,
    labelClassName: undefined,
    wrapperElement: undefined,
    wrapperClassName: undefined
  },
  error: {
    errorClassName: undefined
  },

  // Set to true to request that all inputs have a visual label
  labelAllInputs: false
});
FormThemeContext.displayName = "FormThemeContext";
